<template>
  <div class="self-alignment-container">
    <div v-if="label" class="label">{{ label }}</div>

    <div class="horizontal">
      <button
        id="h-self-without"
        :class="['align-button', { active: options.horizontal === 'unset' }]"
        @click="changed('horizontal', 'unset')"
      >
        <Close />
      </button>
      <button
        id="h-self-flex-start"
        :class="['align-button', { active: options.horizontal === 'flex-start' }]"
        @click="changed('horizontal', 'flex-start')"
      >
        <SelfAlign class="rotate-270" />
      </button>
      <button
        id="h-self-center"
        :class="['align-button', { active: options.horizontal === 'center' }]"
        @click="changed('horizontal', 'center')"
      >
        <SelfAlignMiddle class="rotate-90" />
      </button>
      <button
        id="h-self-flex-end"
        :class="['align-button', { active: options.horizontal === 'flex-end' }]"
        @click="changed('horizontal', 'flex-end')"
      >
        <SelfAlign class="rotate-90" />
      </button>
      <Tooltip target="h-self-flex-start" :text="$t('h-flex-start')"></Tooltip>
      <Tooltip target="h-self-center" :text="$t('h-center')"></Tooltip>
      <Tooltip target="h-self-flex-end" :text="$t('h-flex-end')"></Tooltip>
      <Tooltip target="h-self-without" :text="$t('h-without')"></Tooltip>
    </div>

    <div class="vertical">
      <button
        id="v-self-without"
        :class="['align-button', { active: options.vertical === 'unset' }]"
        @click="changed('vertical', 'unset')"
      >
        <Close />
      </button>
      <button
        id="v-self-flex-start"
        :class="['align-button', { active: options.vertical === 'flex-start' }]"
        @click="changed('vertical', 'flex-start')"
      >
        <SelfAlign />
      </button>
      <button
        id="v-self-center"
        :class="['align-button', { active: options.vertical === 'center' }]"
        @click="changed('vertical', 'center')"
      >
        <SelfAlignMiddle />
      </button>
      <button
        id="v-self-flex-end"
        :class="['align-button', { active: options.vertical === 'flex-end' }]"
        @click="changed('vertical', 'flex-end')"
      >
        <SelfAlign class="rotate-180" />
      </button>
      <Tooltip target="v-self-flex-start" :text="$t('v-flex-start')"></Tooltip>
      <Tooltip target="v-self-center" :text="$t('v-center')"></Tooltip>
      <Tooltip target="v-self-flex-end" :text="$t('v-flex-end')"></Tooltip>
      <Tooltip target="v-self-without" :text="$t('v-without')"></Tooltip>
    </div>
  </div>
</template>

<script>
import SelfAlign from '@/assets/self-align.svg'
import SelfAlignMiddle from '@/assets/self-align-middle.svg'
import Close from '@/assets/close.svg'

export default {
  name: 'Alignment',
  i18nOptions: { keyPrefix: 'components.sidenav.shared.self-alignment' },
  components: {
    SelfAlign,
    SelfAlignMiddle,
    Close,
  },
  props: {
    options: {
      type: Object,
      default() {
        return {
          horizontal: 'unset',
          vertical: 'unset',
        }
      },
    },
    label: {
      type: String,
      default: '',
    },
  },
  methods: {
    changed(axis, value) {
      this.$emit('change', {
        ...this.options,
        [axis]: this.options[axis] === value ? '' : value,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.self-alignment-container {
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;

  .label {
    width: 100%;
    margin-bottom: 5px;
  }

  .align-button {
    margin: 0;
    border: none;
    outline: none;
    cursor: pointer;
    background: white;
    font-size: 24px;

    &.active svg {
      fill: $cherry;
      path {
        stroke: $cherry;
        fill: $cherry;
      }
    }
  }
  .rotate-90 {
    transform: rotate(90deg);
  }
  .rotate-180 {
    transform: rotate(180deg);
  }
  .rotate-270 {
    transform: rotate(270deg);
  }
}
</style>
